/* eslint-disable no-param-reassign */
/* eslint-disable arrow-body-style */
/* eslint-disable no-console */
/* eslint-disable */
import { camelCase } from 'lodash';

/*
 * importImages takes the returned function from require.context normalizes the file names
 * and then returns a function that will accept normalized file names and return file paths
 * If the file being looked up does not exist then an error is thrown.
 */

const importImages = (imageFiles) => {
  const images = imageFiles.keys().reduce((imagesAcc, filename) => {
    const normalizedFilename = camelCase(filename.replace(/\.(jpg|jpeg|png|gif|svg)(\?.*)?$/, ''));

    imagesAcc[normalizedFilename] = imageFiles(filename);

    return imagesAcc;
  }, {});

  const getImage = (filename) => {
    if (typeof images[filename] === 'undefined') {
      throw Error(`Image file ${filename} does not exist.`);
    } else {
      return images[filename];
    }
  };

  const log = () => {
    console.log(images);
  };
  const getAll = () => {
    const imageSrcs = [];

    for (const prop in images) {
      if (images.hasOwnProperty(prop)) {
        imageSrcs.push(images[prop]);
      }
    }

    return imageSrcs;
  };

  getImage.log = log;
  getImage.getAll = getAll;

  return getImage;
};

export default importImages;



// WEBPACK FOOTER //
// ./src/util/webpack.js